// extracted by mini-css-extract-plugin
module.exports = {"option":"Controller_option__WNe1P","labelWrapper":"Controller_labelWrapper__2KZyg"};